module.exports = __webpack_public_path__ + "img/196-4434ff.png";